export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 pt-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="text-xs font-mono-ui uppercase tracking-[0.28em] text-violet-400 mb-3">
              ─── catlyz.co
            </div>
            <p className="text-sm text-zinc-400 max-w-md leading-relaxed">
              A GTM advisory firm architecting profitable, AI-native revenue
              motions for the operators building the next durable companies.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
            <a href="#services" className="text-zinc-400 hover:text-zinc-100 transition-colors">Services</a>
            <a href="#framework" className="text-zinc-400 hover:text-zinc-100 transition-colors">Approach</a>
            <a href="#about" className="text-zinc-400 hover:text-zinc-100 transition-colors">About</a>
            <a href="#contact" className="text-zinc-400 hover:text-zinc-100 transition-colors">Contact</a>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="mt-16 md:mt-24 overflow-hidden">
          <div
            aria-hidden
            className="font-display font-light leading-none tracking-tighter select-none text-transparent"
            style={{
              fontSize: "clamp(72px, 22vw, 320px)",
              WebkitTextStroke: "1px rgba(255,255,255,0.08)",
            }}
          >
            CATLYZ
          </div>
        </div>

        <div className="border-t border-white/5 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-zinc-500 font-mono-ui uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Catlyz Advisory · All rights reserved
          </div>
          <div className="text-xs text-zinc-500 font-mono-ui uppercase tracking-[0.2em]">
            Built for profitable growth
          </div>
        </div>
      </div>
    </footer>
  );
};
